module.exports = __webpack_public_path__ + "static/logo-un-6e498c47b204dc7cfdc39242025c6339.png";